import { render } from "./DimensionsList.vue?vue&type=template&id=99b668b4&scoped=true&ts=true"
import script from "./DimensionsList.vue?vue&type=script&lang=ts"
export * from "./DimensionsList.vue?vue&type=script&lang=ts"

import "./DimensionsList.vue?vue&type=style&index=0&id=99b668b4&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99b668b4"]])

export default __exports__